var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.fullLoading)?_c('div',{attrs:{"id":"loader-wrapper"}},[_c('img',{attrs:{"src":require("@/assets/icons/swap-loading.svg")}})]):_vm._e(),_c('common-header'),_c('div',{staticClass:"main",style:({
      height: _vm.appInfo.hasScrollbar
        ? 'calc(100vh - 70px)'
        : 'calc(100vh - 180px)',
    }),attrs:{"id":"main"}},[(_vm.isShow)?_c('router-view'):_vm._e(),_c('common-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }